<template>
  <div>
    <a-modal title="设置参与秒杀的价格" width="45vw" :visible="visible" @ok="handleOk" @cancel="handleCancel">
      <div class="content">
        <div v-for="item in skuList">
          <p style="font-size: 18px; font-weight: bold">{{ item.skuName }}</p>
          <p>秒杀价格 <a-input-number :min="0" v-model="item.seckillPrice" :max="item.price" /></p>
          <p class="font-size:12px;">售卖价：{{ item.price }}</p>
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import { selectSkuList } from '@/api/goods/goods'
export default {
  data() {
    return {
      visible: false,
      skuList: [],
    }
  },
  methods: {
    handleOk(e) {
      this.visible = false
      this.$emit('ok', this.skuList)
    },
    handleCancel(e) {
      this.visible = false
    },
    showModal(val) {
      console.log(val)
      if (val.skuList.length > 0) {
        this.skuList = val.skuList
      } else {
        this.getSkuList(val.goodsList[0].id)
      }

      this.visible = true
    },
    getSkuList(val) {
      console.log('getsku', val)
      selectSkuList({ goodsId: val }).then((res) => {
        this.skuList = res.data
        console.log(this.skuList)
      })
    },
  },
}
</script>
<style lang="less" scoped>
.content {
  height: 40vh;
  overflow: auto;
  .smPrice {
    font-size: 12px;
  }
  .sku {
    font-size: 18px;
    font-weight: bold;
  }
}
</style>
